import { render, staticRenderFns } from "./PayCpt.vue?vue&type=template&id=0bd1e706&scoped=true&"
import script from "./PayCpt.vue?vue&type=script&lang=js&"
export * from "./PayCpt.vue?vue&type=script&lang=js&"
import style0 from "./PayCpt.vue?vue&type=style&index=0&id=0bd1e706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1e706",
  null
  
)

export default component.exports